module.exports = __webpack_public_path__ + "img/ai-pic3.38120bcd.png";